import axios from "axios";
const Report = async (asesorId) => {
  const re = await axios
    .post(`https://api.sitimm.org/api/reports/show`, {
      reportNumber: 13,
      params: {
        asesorId,
      },
    })
    .then((res) => {
      return res;
    });
  return re;
};

export default Report;
